import React, { useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { Routing } from '../../../util/routes.util';
import { Sidebar, SidebarItem } from '../../components/Sidebar';
import Icon, { IconType } from '../../icons/Icon';
import PersonalInformationSettingsScreen from './PersonalInformation/PersonalInformationSettingsScreen';

export default function ProfileSettingsScreen() {
  const navigate = useNavigate();
  const location = useLocation();

  const items = useMemo(() => {
    return [
      {
        text: t(TranslationKey.personalInformation).singular.label,
        path: Routing.profile.personalInformation(),
        identifier: 'personal_information',
        shown: true,
      },
    ].filter(item => item.shown);
  }, []);

  return (
    <div className='flex flex-grow overflow-hidden'>
      <Sidebar
        first={
          <div className='mx-4'>
            <div className='flex h-[52px] items-center py-2'>
              <button
                className='flex w-fit gap-2 rounded-2 px-3 py-2 hover:bg-gray-100'
                onClick={() => navigate('/dashboard')}
              >
                <Icon type={IconType.arrowNarrowLeft} stroke={'stroke-black'} size={'h-5 w-5'} />
                <p className='text-sm font-medium text-black'>{t(TranslationKey.back).singular.label}</p>
              </button>
            </div>
            <div className='mx-2 flex h-[60px] flex-col justify-center'>
              <p className='text-xl font-medium text-black'>Profile Settings</p>
            </div>
          </div>
        }
        items={items.map(item => (
          <SidebarItem
            selected={location.pathname.split('/profile/')[1] === item.identifier}
            key={item.identifier}
            identifier={item.identifier}
            onClick={() => navigate(item.path)}
            title={item.text}
          >
            <p>{item.text}</p>
          </SidebarItem>
        ))}
      />

      <Routes>
        <Route path='personal_information/*' element={<PersonalInformationSettingsScreen />} />
      </Routes>
    </div>
  );
}
